const withCard = (Component) => (props) =>
  (
    <li className="block w-11/12 flex flex-col p-3 max-w-3xl mb-2 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:text-white dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
      <Component {...props} />
    </li>
  )

export { withCard }
